import React from 'react';
import PropTypes from 'prop-types';

import { registerField } from 'core/forms';

import { Select } from 'uikit/selects';

import getDurationStartOptions from '../helpers/getDurationStartOptions';

import styles from '../styles/formFieldDuration.module.scss';

const FormFieldDuration = ({
  fieldId,
  schema = {
    hourOptions: { count: 12, increment: 1, start: 0 },
    minuteOptions: { count: 55, increment: 5, start: 0 },
  },
  updateField,
  value = null,
}) => {
  const defaultModel = { hour: 1, minute: 0 };

  const { hourOptions, minuteOptions } = schema;

  const { hours, minutes } = getDurationStartOptions({ fieldId, hourOptions, minuteOptions });

  const onChange = (key, option) => {
    updateField({
      ...(value ?? defaultModel),
      [key]: option?.value ?? '',
      ...(key === 'hour' && option.value === 24 && {
        minute: 0,
      }),
    });
  };

  return (
    <div className={styles.element}>
      <Select
        className={styles.select}
        classNamePrefix="forms__form-field-select"
        id={`${fieldId}-hour-select`}
        options={hours}
        value={hours?.find((option) => option.value === (value?.hour ?? defaultModel.hour))}
        onChange={(option) => onChange('hour', option)}
      />
      <Select
        className={styles.select}
        classNamePrefix="forms__form-field-select"
        id={`${fieldId}-minutes-select`}
        options={minutes}
        value={minutes?.find((option) => option.value === (value?.minute ?? defaultModel.minute))}
        onChange={(option) => onChange('minute', option)}
        isDisabled={(value?.hour === 24)}
      />
    </div>
  );
};

FormFieldDuration.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      hour: PropTypes.number,
      minute: PropTypes.number,
    }),
    PropTypes.number,
  ]),
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    hourOptions: PropTypes.shape({
      start: PropTypes.number,
      count: PropTypes.number,
      increment: PropTypes.number,
    }),
    minuteOptions: PropTypes.shape({
      start: PropTypes.number,
      count: PropTypes.number,
      increment: PropTypes.number,
    }),
  }),
};

registerField('Duration', React.memo(FormFieldDuration));
